import { OptimisticMutationConfig } from "@urql/exchange-graphcache";

export const optimistic: OptimisticMutationConfig = {};
